import PaginationControls from "../../../../../../components/base/PaginationControls";

interface DevicePaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  t: (key: string, options?: any) => string;
}

export function DevicePagination({
  currentPage,
  totalPages,
  onPageChange,
}: DevicePaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <PaginationControls
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
    />
  );
}
